import OSfPhoneDial from './index.vue';

OSfPhoneDial.install = app => {
  app.component(OSfPhoneDial.name, OSfPhoneDial);
};

export default OSfPhoneDial;
